// 对http请求进行封装
import axios from 'axios'
import { Message } from 'element-ui'
// const store = require('@/store')

// 使用自定义的配置文件发送请求
const instance = axios.create({
  baseURL: '',
  timeout: 10000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
})

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  console.log('response',response)
  // 对响应数据做点什么
  if (response.status === 200) {
    return response.data
  } else {
    console.error('请求错误')
    console.error(response)
  }
  return response
}, function ({response}) {
  console.log('error')
  Message.error(response.data.msg)
  // 对响应错误做点什么
  return Promise.reject(response.data)
})

// 默认导出  只能有一个默认导出，可以自己起名字，导入时可以不加{}
export default instance



// WEBPACK FOOTER //
// ./src/api/http.js